<template lang="html">
  <div class="merchant-container">
    <div class="breadCrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{$t('message.TerminalList')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('message.TerminalReportDetail')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="flex-row second-tip">
      <div class="title"></div>
      <div class="flex-row search-container">
        <div class="select-input-container" style="right:50px" >
        <el-input class="reachInput"
                  :placeholder="$t('message.enterKeyword')"
                  v-model="terminalSearch"  @keyup.enter.native="searchTerminallist"
                  clearable>
        </el-input>
          <el-select class="rearchSelect" v-model="queryType" :placeholder="$t('message.pleaseChoose')"  >
            <el-option v-for="item in queryOptions" :key="item.value" :label="item.label" :value="item.value" @click.native="getDivision()">
            </el-option>
          </el-select>
        </div>
        <el-button  class="search-btn" icon="el-icon-search" @click="searchTerminallist"></el-button>
       <el-button  class="verifone-btn" type="primary" plain icon="el-icon-user" @click="exportExcel">{{$t('message.export')}}</el-button>
      </div>
    </div>
    <div class="verifone-panel">
      <div class="appManagement-table-main btn-table">
        <template>
          <el-table :data="tableData" style="width: 100%" tooltip-effect="dark" id="exportXlsx">
            <el-table-column  prop="sn"  :label="$t('message.sn')" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column  prop="resellerName" :label="$t('message.resellerName')" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column  prop="model" :label="$t('message.model')" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column  prop="lat" :label="$t('message.lat')" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column  prop="lng" :label="$t('message.lng')" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column  prop="createTime" :label="$t('message.createTime')" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column  prop="merchantName" :label="$t('message.merchantName')" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column  prop="timeZone" :label="$t('message.timeZone')" :show-overflow-tooltip="true"></el-table-column>
            <!-- <el-table-column  :label="$t('message.operation')" width="240" align="center" v-if="queryFlag">
              <template slot-scope="scope">
                <router-link :to="{path:'/merchantAdde/',query:{id:scope.row.id}}">
                  <el-button type="success" class="op-btn verifone-btn" plain icon="el-icon-edit">{{$t('message.edit')}}</el-button>
                </router-link>
                <el-button type="danger" class="op-btn verifone-btn" plain icon="el-icon-close" @click="showDeleteDialog(scope.row)">{{$t('message.delete')}}</el-button>
              </template>
            </el-table-column> -->
           <!-- <el-table-column  :label="$t('message.operation')" width="240" align="center" v-else>
              <template slot-scope="scope">
                  <router-link :to="{path:'/merchantAdde/',query:{id:scope.row.id}}">
                      <el-button type="success" disabled class="op-btn verifone-btn" plain icon="el-icon-edit">{{$t('message.edit')}}</el-button>
                </router-link>
                <el-button disabled type="danger" class="op-btn verifone-btn" plain icon="el-icon-close" @click="showDeleteDialog(scope.row)">{{$t('message.delete')}}</el-button>
              </template>
            </el-table-column> -->
          </el-table>
        </template>

        <div class="pagination-main">
          <el-pagination @current-change="handleCurrentChange"
                         background layout="prev, pager, next"
                         :current-page="pageNum"
                         :page-count="pageCount">
          </el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>


  export default {
    data() {
      return {
        pageNum :1,
        pageCount:1,
        sn :'',
        resellerName: '',
        model:'',
        lat: '',
        lng:'',
        createTime:'',
        merchantName:'',
        timeZone:'',
        researchType:0,//0 为查询分页查询APP 1搜索APP
        tableData: [],
        terminalSearch:'',
        queryFlag: false,
        exportLoading:'',
        queryOptions: [ {
          value: 0,
          label: this.$t('message.sn')
        },{
          value: 1,
          label: this.$t('message.resellerName')
        },{
          value: 2,
          label: this.$t('message.model')
        },{
          value: 3,
          label: this.$t('message.merchantName')
        }],
        queryType: 0,

      }
    },
    mounted() {
      this.queryTerminalList();
      this.setQuery();
    },
    methods: {
      getDivision(){
        this.terminalSearch='';
      },
        setQuery() {
            let roleArr = sessionStorage.getItem('verifoneRoleList').split(',').map(str => parseInt(str));
            this.queryFlag = !roleArr.includes(11);
        },
      handleCurrentChange(val) {
        console.log("val"+val);
        this.pageNum = val;
        if(this.researchType == 0) {
          this.queryTerminalList();
        }
        else if(this.researchType == 1) {
          this.searchTerminallist();
        }
      },
      queryTerminalList() {
        let that = this,
            obj = {
              pageNum:this.pageNum
            };

        this.$axios({
            method: 'post',
            url: '/marketplace/report/terminalReportPage',
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
            data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration:'3000',
            });
            return;
          }else {
            that.researchType = 0;
            that.pageCount = response.data.totalPage;
            that.tableData= response.data.list;
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      searchTerminallist() {
        let that = this,
            obj = {
              queryType:this.queryType,
              queryInfo:this.terminalSearch,
              pageNum:this.pageNum
            };

        if(this.terminalSearch == '') {
            this.pageNum = 1;
            this.historySearch = '';
            this.queryTerminalList();
            return;
        }

        //new query => refresh page
        if(this.terminalSearch != this.historySearch) {
            this.pageNum = 1;
        }else {
            obj.pageNum = this.pageNum;
        }

        this.$axios({
            method: 'post',
            url: '/marketplace/report/terminalReportSearch',
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
            data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration:'3000',
            });
            return;
          }else {
            that.researchType = 1;
            that.tableData = response.data.list;
            that.pageCount = response.data.totalPage;
            that.historySearch = that.terminalSearch;
          }
        }).catch((err) => {
          console.log(err);
        });
      },
     exportExcel(){
           console.log("111111");
           this.exportLoading = true;
           this.$axios({
              type:'post',
              url:'/marketplace/terminal/exportTerminalExcel',
/*              headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')}, */
              timeout: 600000,
              responseType: 'blob'
            }).then(res=>{
             debugger;
             if(!res) {
                 this.$notify.error({
                   title: '操作失败',
                   message: '文件下载失败'
                 })
             }
             let blob = new Blob([res.data],{type: 'application/vnd.ms-excel'});
              if (window.navigator.msSaveBlob) {    //IE以及IE内核的浏览器使用
                         try {
                           window.navigator.msSaveBlob(blob, '终端' + '.xls');
                           // window.navigator.msSaveOrOpenBlob(response, fileNm);    //fileNm是文件的名字
                         } catch (e) {
                           console.log(e);
                         }
                       }
                       else{
                     /*    const link = document.createElement('a')
                         link.style.display = 'none'
                         link.href =  URL.createObjectURL(blob);
                         let num = ''
                          for(let i=0;i < 10;i++){
                            num += Math.ceil(Math.random() * 10)
                          }
                          link.setAttribute('download', '终端_' + num + '.xlsx')
                          document.body.appendChild(link)
                          link.click()
                          document.body.removeChild(link) */
                       }
           }).catch(error => {
            console.log(error)
            })
         },
    }
  }
</script>

<style lang="css" scoped="scope">

  .select-input-container{
    border: #8c939d;
  }
  .appManagement-container {
    /*background-color: #E0EAF4;*/
    overflow: hidden;
    display: flex;
    display: -webkit-flex;
    /*justify-content: center;*/
    align-items: center;
    width: 100%;
  }
  .appManagement-table {
    width:100%;
    padding:10px 30px;
  }
  .appManagement-table-main {
    padding: 20px;
    background-color: #fff;
  }
  .pagination-main {
    padding:30px 0 10px;
    background: #fff;
    width: 100%;
  }
  .appManagement-search .el-input__inner {
    border-radius: 20px;
  }
 .reachInput {
    position: relative;
   /* border-right:none!important;*/
    left: 40px;
  }
  .search-btn {
    margin-right: 30px;
  }
  .rearchSelect {
    width: 150px;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/report/TerminalListReport.vue